export default __webpack_public_path__ + "static/media/SignUpArtWork.57ba0b83.svg";